export default "__VITE_ASSET__BlzYkTnq__"